// 标签管理 模块  接口管理
import request from '../request.js'

// 标签汇总 搜索查询 --- 郑志会
export const getAllTag = function (data) {
    return request({
        url: 'operateTagType/getAllTag',
        method: 'post',
        data
    })
}

// 标签汇总 查看详细 --- 郑志会
export const getDetail = function (data) {
    return request({
        url: 'operateTag/getTagInfo',
        method: 'post',
        data
    })
}

// 标签汇总 设为公共标签 --- 郑志会
export const setCommonTag = function (data) {
    return request({
        url: 'operateTag/saveOneObjectTag',
        method: 'post',
        data
    })
}

// ---- 标签维护
// 分页查询 --- 俞祥东
export const getTagsList = function (data) {
    return request({
        url: 'operateTag/selObjectTagPageList',
        method: 'post',
        data
    })
}

// 新增or保存标签接口 --- 俞祥东
export const saveOrUpdate = function (data) {
    return request({
        url: 'operateTag/savePlatTag',
        method: 'post',
        data
    })
}

// 删除标签 --- 俞祥东
export const deleteTag = function (data) {
    return request({
        url: 'operateTag/delObjectTagById',
        method: 'post',
        data
    })
}

// 设置标签状态 --- 俞祥东
export const setTagFlag = function (data) {
    return request({
        url: 'operateTag/setObjectTagStatus',
        method: 'post',
        data
    })
}

// 获取码表 --- 崔北超
export const selectSysDictByParent = function (data) {
    return request({
        url: 'sysDict/selectSysDictByParent',
        method: 'post',
        data
    })
}

// 获取左侧树 --- 崔北超
export const selectGroupData = function (data) {
    return request({
        url: 'operateTagGroup/selectGroupData',
        method: 'post',
        data
    })
}

// 新增标签分组 --- 崔北超
export const saveOrUpdateGroup = function (data) {
    return request({
        url: '/operateTagGroup/saveOrUpdateGroup',
        method: 'post',
        data
    })
}